import { initBackForward } from './widgets/toolbox/history';

export function initPageEvents(): void {
    initBackForward();
}
